import "scripts/templates/blog.js";
import { registerBundle } from "scripts/lib/register-bundle.js";
registerBundle("template.blog");
